import { Box, Button, Container } from '@mui/material';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import Logo, { LOGO_TYPE } from '@product-framework/components/Logo';
import { Footer, IconLibrary } from '@product-framework/index';
import { Page, PublicBreadcrumb, useLocalization } from '@ui-framework/index';
import { FormattedMessage } from 'react-intl';
import { useHref, useNavigate } from 'react-router-dom';

function PublicHelpLayout({ breadcrumbs, children }) {
  const navigate = useNavigate();
  const homeHref = useHref('/');
  const { formatMessage } = useLocalization();
  const publicBreadcrumbs = [
    {
      name: formatMessage({ id: 'HOME', defaultMessage: 'Home' }),
      icon: IconLibrary.Home,
      onClick: () => navigate('/'),
    },
    ...breadcrumbs,
  ];
  const loginAction = () => {
    navigate('/');
  };

  return (
    <Page>
      <Container>
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
          }}>
          <Grid2 container>
            <Grid2 xs={6} sx={{ mt: 1 }}>
              <Logo type={LOGO_TYPE.FULL} size="medium" href={homeHref} />
            </Grid2>
            <Grid2 xs={6} sx={{ mt: 1, textAlign: 'right' }}>
              <Button variant="contained" size="small" onClick={loginAction}>
                <FormattedMessage id="LOGIN" defaultMessage="Login" />
              </Button>
            </Grid2>
          </Grid2>
          <Box sx={{ mb: 1 }}>
            <PublicBreadcrumb items={publicBreadcrumbs} />
          </Box>
          <Box sx={{ flex: 1 }}>{children}</Box>
          <Footer maxWidth="xl" />
        </Box>
      </Container>
    </Page>
  );
}

export default PublicHelpLayout;
